// extracted by mini-css-extract-plugin
export default {"maincontainer":"EditHome_maincontainer__+QEAL","formcontainer":"EditHome_formcontainer__yC7KK","componentcontainer":"EditHome_componentcontainer__pwrc7"};